// pages/ResultPage.jsx
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import ResultList from "../components/result/ResultList";
import EmptyState from "../components/result/EmptyState";
import { useTranslation } from "react-i18next";
import { httpRequest } from "../utils/httpRequest";

const ResultPage = () => {
  const { t, i18n } = useTranslation();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const user = JSON.parse(localStorage.getItem("user")); // گرفتن کاربر لاگین‌شده
  const isRtl = i18n.language.includes("fa");

  useEffect(() => {
    if (user?._id) getData();
  }, [user?._id]);

  const getData = async () => {
    setLoading(true);
    setError(null);
    try {
      const resp = await httpRequest(
        "GET",
        `/result/user/list`,
        {},
        { "x-access-token": user?.token }
      );

      const serverResults = resp?.data?.data || resp?.data || [];

      setResults(serverResults);
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  // کلاس‌های Tailwind
  const mainContentClass = `flex-1 flex flex-col px-2 pb-5 lg:px-0 lg:pb-0 ${
    isRtl ? "md:mr-64" : "md:ml-64"
  }`;
  const mainSectionClass = `flex-1 overflow-y-auto p-4 md:p-6 bg-gray-100 rounded-[16px] ${
    isRtl ? "lg:me-3 lg:mb-3" : "lg:ms-3 lg:mb-3"
  }`;

  return (
    <div className="flex h-screen">
      <Helmet>
        <title>{t("results.page_title")}</title>
      </Helmet>

      <Sidebar />
      <div className={mainContentClass}>
        <Header />
        <main className={mainSectionClass}>
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            {t("results.page_header")}
          </h1>

          {loading ? (
            <div className="text-center text-gray-500">
              {t("common.loading")}
            </div>
          ) : error ? (
            <div className="p-4 bg-red-50 text-red-700 rounded-xl">
              {t("common.error")}: {error}
            </div>
          ) : results.length > 0 ? (
            <ResultList results={results} />
          ) : (
            <EmptyState message={t("results.empty_state_message")} />
          )}
        </main>
      </div>
    </div>
  );
};

export default ResultPage;
